import { render } from "./PrepareDetail.vue?vue&type=template&id=5ec490ae&scoped=true"
import script from "./PrepareDetail.vue?vue&type=script&lang=js"
export * from "./PrepareDetail.vue?vue&type=script&lang=js"

import "./PrepareDetail.vue?vue&type=style&index=0&id=5ec490ae&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec490ae"]])

export default __exports__